import { getSingleProductPath } from '@/src/routes/routes'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Mousewheel } from 'swiper/modules'
import ImageComponent from '@/src/components/common/ImageComponent'
import Link from 'next/link'
import { ArrowUpRightSVG } from '@/src/ui/AllSVG'
import AddToWishlist from '../../page-components/products/AddToWishlist'
import type { IRecentlyViewedProductAPIResponseDataEntity } from '@/src/types/recentlyViewedProduct'

interface SuggestedResultProps {
    suggestedProducts: IRecentlyViewedProductAPIResponseDataEntity[]
    onClose: () => void
}
export default function SuggestedResult({ suggestedProducts, onClose }: SuggestedResultProps) {

    return (
        <>
            {suggestedProducts && suggestedProducts?.length > 0 && <h3 className="text-sm font-semibold tracking-[0.14px] uppercase">Recently Viewed Products</h3>}
            {suggestedProducts && suggestedProducts?.length > 0 && (
                <Swiper
                    modules={[FreeMode, Mousewheel]}
                    slidesPerView={2.2}
                    spaceBetween={12}
                    freeMode={{ enabled: true, momentum: true, momentumRatio: 0.4 }}
                    mousewheel={{ forceToAxis: true, releaseOnEdges: true }}
                    breakpoints={{
                        480: { slidesPerView: 2.5 },
                        640: { slidesPerView: 2.2 },
                        1024: { slidesPerView: 2.5 },
                    }}
                >
                    {suggestedProducts && suggestedProducts?.length > 0 && suggestedProducts?.map((item) => (
                        <SwiperSlide key={item?.product?._id}>
                            <Link
                                href={getSingleProductPath(item?.product?.slug ?? '')}
                                onClick={onClose}
                                className="group space-y-3 cursor-pointer block"
                            >
                                <div className="relative aspect-4/5 w-full bg-secondary-background-color rounded-xl overflow-hidden">
                                    <ImageComponent
                                        src={item?.product?.variants?.[0]?.images?.[0] ?? item?.product?.thumbnail ?? ''}
                                        alt={item?.product?.title ?? ''}
                                        object_cover={false}
                                        priority={false}
                                    />
                                    <div className="wishlist_btn absolute top-3 right-3 z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                        <AddToWishlist product_id={item?.product?._id} isAlreadyWishlist={item?.product?.alreadyWishlist} />
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <p className="text-xs font-medium truncate">{item?.product?.title ?? ''}</p>
                                    <p className="text-[10px] tracking-[0.14px] uppercase flex items-center gap-1 underline underline-offset-2">
                                        Explore Now
                                        <ArrowUpRightSVG className="text-body-color" />
                                    </p>
                                </div>
                            </Link>
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
        </>
    )
}
